module.exports = __webpack_public_path__ + "img/title-oldmg.7c75d760.png";